import { useSyncExternalStore } from "react";

const KEY = "ideaforge_ideas";
const listeners = new Set();
let cache = load();

function load() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

function write(next) {
  cache = next;
  localStorage.setItem(KEY, JSON.stringify(next));
  listeners.forEach((l) => l());
}

export const ideasStore = {
  get: (id) => cache.find((i) => i.id === id),
  upsert(ideas) {
    const map = new Map(cache.map((i) => [i.id, i]));
    ideas.forEach((i) => map.set(i.id, { saved: false, favorite: false, ...map.get(i.id), ...i }));
    write([...map.values()]);
  },
  update(id, patch) {
    write(cache.map((i) => (i.id === id ? { ...i, ...patch } : i)));
  },
  remove(id) {
    write(cache.map((i) => (i.id === id ? { ...i, saved: false, favorite: false } : i)));
  },
};

const subscribe = (l) => {
  listeners.add(l);
  return () => listeners.delete(l);
};

export function useIdeas() {
  return useSyncExternalStore(subscribe, () => cache);
}
